import React, { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { AppContext } from "../../../components/AppProvider";
import { PostApi1950 } from "../../../modules/network/padoPost";
import { PeriodEvent } from "../../common/Event/PeriodEvent";
import { DateLayerPopup } from "../../Layout";
import DateInputRange from "./DateInputRange";
import HistoryList from "./HistoryList";
import useTitle from "../../../modules/hooks/useTitle";

export default props => {
  useTitle("자가건강관리_검사결과_이력");
  const { userinfo, cfg } = useContext(AppContext);
  const [searchListTarget, setSearchListTarget] = useState("hba1c");
  const [periodBtnOn, setPeriodBtnOn] = useState(3);
  const [srchFrDt, setSrchFrDt] = useState();
  const [srchToDt, setSrchToDt] = useState();

  const [dataList, setDataList] = useState();
  const [dateTarget, setDateTarget] = useState("FROM");
  const [isDisplay, setIsDisplay] = useState(false);

  const LoadingDataList = () => {
    PostApi1950(
      userinfo,
      cfg,
      periodBtnOn,
      periodBtnOn == 4 ? srchFrDt : PeriodEvent(periodBtnOn).startDate,
      periodBtnOn == 4 ? srchToDt : PeriodEvent(periodBtnOn).endDate,
      searchListTarget
    )
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (searchListTarget === "") {
            // setDataList(res.result.map(list => (
            // )))
          } else {
            setDataList(res.result);
          }

          props.setReload(false);
        }
      })
      .catch(err => {
        alert(err);
      });
  };

  const settingSearchListTarget = data => {
    setSearchListTarget(data);

    props.setReload(true);
  };

  const settingSearchFromDate = date => {
    if (dateTarget === "FROM") {
      setSrchFrDt(date);
    } else {
      setSrchToDt(date);
    }

    setIsDisplay(false);
    props.setReload(true);
  };

  useEffect(() => {
    if (props.reload === true) {
      if (periodBtnOn === 4) {
        if (srchFrDt && srchToDt) {
          if (srchToDt >= srchFrDt) {
            LoadingDataList();
          } else {
            alert("잘못된 검색기간 입니다.");
          }
        }
      } else {
        LoadingDataList();
      }
    }
  }, [searchListTarget, props.reload, srchFrDt, srchToDt]);

  return (
    <Fragment>
      <SectionDiv>
        <SectionTitle>기간선택</SectionTitle>

        <div className="full-input">
          {/* <div className="inp-with-unit"> */}
          <div>
            <div>
              <div
                style={{
                  display: "flex",
                }}>
                <PeriodBotton
                  onClick={() => {
                    setPeriodBtnOn(1);
                    props.setReload(true);
                  }}
                  on={periodBtnOn === 1 ? "true" : "false"}>
                  3개월
                </PeriodBotton>
                <PeriodBotton
                  onClick={() => {
                    setPeriodBtnOn(2);
                    props.setReload(true);
                  }}
                  on={periodBtnOn === 2 ? "true" : "false"}>
                  6개월
                </PeriodBotton>
                <PeriodBotton
                  onClick={() => {
                    setPeriodBtnOn(3);
                    props.setReload(true);
                  }}
                  on={periodBtnOn === 3 ? "true" : "false"}>
                  1년
                </PeriodBotton>
                <PeriodBotton
                  onClick={() => {
                    setPeriodBtnOn(4);
                    props.setReload(true);
                  }}
                  on={periodBtnOn === 4 ? "true" : "false"}
                  last="last">
                  기간설정
                </PeriodBotton>
              </div>

              {periodBtnOn === 4 && (
                <SectionSubDiv>
                  {/* <DateLayer color="green" /> */}
                  <DateInputRange
                    setIsDisplay={setIsDisplay}
                    setDateTarget={setDateTarget}
                    srchFrDt={srchFrDt}
                    srchToDt={srchToDt}
                  />
                </SectionSubDiv>
              )}
            </div>
          </div>
        </div>
      </SectionDiv>

      {/* 검사선택 2022-12-22 기획문서에서 제외 */}
      {/* <SectionDiv>
          <SectionTitle>
            검사선택
            <DivSelectBox
              selectList={props.inputTitle}
              setSearchListTarget={settingSearchListTarget}
            />
          </SectionTitle>
        </SectionDiv> */}

      {/* 리스트 */}
      {
        dataList && (
          <DataListArea
            dataList={dataList}
            setTargetList={props.setTargetList}
            checkAll={props.checkAll}
            setCheckAll={props.setCheckAll}
          />
        )
        // :   <>없음</>
      }

      {isDisplay && (
        <DateLayerPopup
          isDisplay={isDisplay}
          setIsDisplay={setIsDisplay}
          settingSearchFromDate={settingSearchFromDate}
          color={"green"}
          startDate={props.startDate}
        />
      )}
    </Fragment>
  );
};

const DivSelectBox = (props) => {
  // selectList = [{text : 'aaa', value : '1'}]
  const [optionVeiw, setOptionView] = useState(false);
  const [selectedText, setSelectedText] = useState("당화혈색소");

  const onClickList = (target) => {
    props.setSearchListTarget(target.code);
    setSelectedText(target.name);
    setOptionView(false);
  };

  return (
    <div
      className={
        optionVeiw
          ? "select-custom-box bfaf-select on"
          : "select-custom-box bfaf-select"
      }
      style={{ paddingTop: "16px" }}
    >
      <a className="btn-select" onClick={() => setOptionView(true)}>
        {/* {props.selectList[0].name} */}
        {selectedText}
      </a>
      <ul style={{ top: "65px" }}>
        <li onClick={() => onClickList({ name: "전체", code: "" })}>
          <a>전체</a>
        </li>
        {props.selectList.map((m, i) => (
          <li key={"selectList" + i} onClick={() => onClickList(m)}>
            <a>{m.name}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

const DataListArea = (props) => {
  const checkDeleteAll = () => {
    // props.setTargetList('DELETE', data, e);
  };

  return props.dataList.map((m, i) => (
    <Fragment key={"dataListArea" + i}>
      {i === 0 && (
        <Fragment>
          <SectionDiv key={"dataArea" + i}>
            <FlexDiv>
              <SectionTitle fontSize="14px">{m.studItemNm}</SectionTitle>
              {/* <TitleDesc>
                  4.0~6.0% 정상
                </TitleDesc> */}
            </FlexDiv>

            <SectionSubDiv>
              <FlexDiv align="left">
                <div>
                  <div style={{ display: "flex" }}>
                    <label className="check-box" style={{ marginLeft: "16px" }}>
                      <input
                        type="checkbox"
                        name="checkSeqNoAll"
                        onClick={(e) => props.setCheckAll(e)}
                      />
                      <i />
                      <span>전체선택</span>
                    </label>
                  </div>
                </div>
              </FlexDiv>
            </SectionSubDiv>
          </SectionDiv>
        </Fragment>
      )}

      <ListDiv endData={props.dataList.length - 1 === i ? "true" : "false"}>
        <HistoryList dataInfo={m} setTargetList={props.setTargetList} />
      </ListDiv>
    </Fragment>
  ));
};

const SectionDiv = styled.div`
  padding-top: 32px;
  padding-left: 16px;
  padding-right: 16px;
`;

const SectionSubDiv = styled.div`
  padding-top: 16px;
`;

const SectionTitle = styled.div`
  font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
  font-weight: 700;
`;

const PeriodBotton = styled.div`
  display: inline-block;
  vertical-align: top;
  width: 24%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 7px;
  font-size: 14px;
  background: ${(props) => (props.on === "true" ? "#b1b1b1" : "#f0f0f0")};
  color: ${(props) => (props.on === "true" ? "#fff" : "#666")};
  margin-right: ${(props) => (props.last ? "0%" : "1%")};
`;

const FlexDiv = styled.div`
  display: flex;
  ${(props) => props.align === "right" && "justify-content: flex-end"}
`;

const ListDiv = styled.div`
  border: 1px solid #d0d0d0;
  min-height: 65px;
  position: relative;
  border-radius: 10px;
  padding: 16px;
  margin: 10px 16px 0px;

  ${(props) => props.endData === "true" && "margin-bottom: 60px;"}
`;
